// extracted by mini-css-extract-plugin
export default {"main":"BPointsLeaderboard_main__O+rt9","header":"BPointsLeaderboard_header__8F759","title":"BPointsLeaderboard_title__jk6nq"};